import { render, staticRenderFns } from "./FlashProducts.vue?vue&type=template&id=5d2cb534&"
import script from "./FlashProducts.vue?vue&type=script&lang=js&"
export * from "./FlashProducts.vue?vue&type=script&lang=js&"
import style0 from "./FlashProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports